import React, { useRef, useEffect } from 'react';

// SVG Path data extracted from Figma
const svgPaths = {
  p295a3200: "M68.1 100.599H38.1L33.6 33.6H111.1V58.1C103.6 57.6 85.8 55.8 74.6 60.6C63.4 65.4 63.4333 92.9327 68.1 100.599Z",
  p17781bc0: "M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z",
  p308b3530: "M8 14.6667C10.6667 12 13.3333 9.61218 13.3333 6.66667C13.3333 3.72115 10.9455 1.33333 8 1.33333C5.05448 1.33333 2.66667 3.72115 2.66667 6.66667C2.66667 9.61218 5.33333 12 8 14.6667Z",
  p2e325700: "M13.8609 8.40416C14.0237 8.26466 14.105 8.19491 14.1348 8.11191C14.161 8.03906 14.161 7.95938 14.1348 7.88653C14.105 7.80353 14.0237 7.73378 13.8609 7.59428L8.21376 2.75387C7.9336 2.51373 7.79353 2.39367 7.67493 2.39073C7.57186 2.38817 7.47341 2.43345 7.40828 2.51337C7.33333 2.60533 7.33333 2.78982 7.33333 3.1588V6.02231C5.91021 6.27128 4.60773 6.99239 3.63981 8.07513C2.58455 9.25556 2.00082 10.7832 2 12.3665V12.7745C2.69956 11.9318 3.573 11.2502 4.56051 10.7765C5.43113 10.3588 6.37228 10.1114 7.33333 10.0462V12.8396C7.33333 13.2086 7.33333 13.3931 7.40828 13.4851C7.47341 13.565 7.57186 13.6103 7.67493 13.6077C7.79353 13.6048 7.9336 13.4847 8.21376 13.2446L13.8609 8.40416Z",
  p113eee80: "M1.35 66.35V14.35C1.35 7.1703 7.1703 1.35 14.35 1.35H78.35",
  pe942ca0: "M1.35 34.35V15.35C1.35 7.61801 7.61802 1.35 15.35 1.35H34.35"
};

const Divider = () => (
  <div style={{
    alignSelf: 'stretch',
    height: '1px',
    background: 'linear-gradient(90deg, transparent 0%, rgba(216,161,52,0.1) 20%, rgba(216,161,52,0.4) 45%, rgba(216,161,52,0.5) 50%, rgba(216,161,52,0.4) 55%, rgba(216,161,52,0.1) 80%, transparent 100%)',
    flexShrink: 0
  }} />
);

export default function AthleteCard({ image, name, sport, location, timeLabel, athleteNumber, spotlightLabel, onBadgeClick }) {
  const spotlightLabelRef = useRef(null);

  useEffect(() => {
    const el = spotlightLabelRef.current;
    if (!el || !spotlightLabel) return;
    let size = 11;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > el.offsetWidth && size > 7) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }, [spotlightLabel]);

  return (
    <div
      className="athlete-card-wrapper"
      onClick={onBadgeClick}
      style={{
        position: 'relative',
        backgroundColor: '#000000',
        borderRadius: '20px',
        height: '400px',
        width: '271px',
        overflow: 'hidden',
        cursor: 'pointer',
        border: '1.5px solid rgba(216,161,52,0.6)',
        WebkitMaskImage: '-webkit-radial-gradient(white, black)'
      }}
    >

      {/* Group9 - Top left blur effects */}
      <div style={{ position: 'absolute', left: '-63px', top: '-23px' }}>
        {/* MaskGroup1 */}
        <div style={{ position: 'absolute', left: '0', top: '1.46px' }}>
          <div style={{
            position: 'absolute',
            top: '1.46px',
            left: '0',
            width: '281px',
            height: '358.418px',
            background: 'linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 81.928%)',
            opacity: '0.06',
            WebkitMaskImage: `url('/assets/images/mask-gradient.png')`,
            maskImage: `url('/assets/images/mask-gradient.png')`,
            WebkitMaskSize: '281px 358.082px',
            maskSize: '281px 358.082px',
            WebkitMaskPosition: '0px 0px',
            maskPosition: '0px 0px',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat'
          }} />
        </div>

        {/* Gray blur shape */}
        <div style={{
          position: 'absolute',
          left: '-61px',
          top: '-21px',
          width: '77.5px',
          height: '66.999px',
          mixBlendMode: 'lighten'
        }}>
          <div style={{
            position: 'absolute',
            top: '-50.15%',
            left: '-43.35%',
            right: '-43.35%',
            bottom: '-50.15%'
          }}>
            <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 144.7 134.199">
              <g filter="url(#filter0_f_1_529)" opacity="0.6" style={{ mixBlendMode: 'lighten' }}>
                <path d={svgPaths.p295a3200} fill="#4F4F4F" />
              </g>
              <defs>
                <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="134.199" id="filter0_f_1_529" width="144.7" x="0" y="0">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                  <feGaussianBlur result="effect1_foregroundBlur_1_529" stdDeviation="16.8" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>

        {/* Gold ellipse blur */}
        <div style={{
          position: 'absolute',
          left: '123px',
          top: '36.5px',
          width: '137px',
          height: '121px'
        }}>
          <div style={{
            position: 'absolute',
            top: '-137.6%',
            left: '-121.53%',
            right: '-121.53%',
            bottom: '-137.6%'
          }}>
            <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 470 454">
              <g filter="url(#filter0_f_1_527)">
                <ellipse cx="235" cy="227" fill="#D8A134" rx="68.5" ry="60.5" />
              </g>
              <defs>
                <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="454" id="filter0_f_1_527" width="470" x="0" y="0">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                  <feGaussianBlur result="effect1_foregroundBlur_1_527" stdDeviation="83.25" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      {/* Top Gold Blur - Large */}
      <div style={{ position: 'absolute', left: '-35px', top: '-215px', width: '337px', height: '337px' }}>
        <div style={{
          position: 'absolute',
          top: '-75.91%',
          left: '-75.91%',
          right: '-75.91%',
          bottom: '-75.91%'
        }}>
          <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 848.6 848.6">
            <g filter="url(#filter0_f_1_503)">
              <circle cx="424.3" cy="424.3" fill="#D8A134" r="168.5" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="848.6" id="filter0_f_1_503" width="848.6" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_1_503" stdDeviation="127.9" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>

      {/* Gradient transition layer - blend yellow to black */}
      <div style={{
        position: 'absolute',
        bottom: '60px',
        left: '0',
        right: '0',
        height: '200px',
        zIndex: '2',
        background: 'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.8) 40%, rgba(0, 0, 0, 0.8) 60%, rgba(0, 0, 0, 0.7) 80%, rgba(0, 0, 0, 0.9) 100%)'
      }} />

      {/* Dots texture pattern - Bottom section only */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '170px',
        zIndex: '3'
      }}>
        {/* Texture dots layer */}
        <div style={{
          position: 'absolute',
          inset: '0',
          backgroundImage: `url('/assets/images/texture-bg.png')`,
          backgroundSize: '379px 379px',
          backgroundPosition: 'center',
          backgroundRepeat: 'repeat',
          opacity: '0.6',
          filter: 'sepia(0.4) saturate(1.5) hue-rotate(25deg)'
        }} />
        {/* Gradient overlay to blend dots from center */}
        <div style={{
          position: 'absolute',
          inset: '0',
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.8) 15%, rgba(0, 0, 0, 0.8) 50%, rgba(0, 0, 0, 0.7) 100%)',
          mixBlendMode: 'multiply'
        }} />
      </div>

      {/* MaskGroup2 - Blur effects */}
      <div style={{ position: 'absolute', bottom: '-2px', right: '-2px', zIndex: '1' }}>

        {/* Color dodge blur - Rotated 180deg */}
        <div style={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          left: '-63.17px',
          top: '176.91px',
          width: '320.904px',
          height: '271.632px',
          mixBlendMode: 'color-dodge'
        }}>
          <div style={{ flex: 'none', transform: 'rotate(180deg)' }}>
            <div style={{ height: '271.632px', opacity: '0.8', position: 'relative', width: '320.904px' }}>
              <div style={{
                position: 'absolute',
                top: '-39.56%',
                left: '-33.48%',
                right: '-33.48%',
                bottom: '-39.56%'
              }}>
                <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 535.809 486.537">
                  <g filter="url(#filter0_f_1_501)" opacity="0.6" style={{ mixBlendMode: 'color-dodge' }}>
                    <ellipse cx="267.905" cy="243.268" fill="#B7B7B7" fillOpacity="0.6" rx="160.452" ry="135.816" />
                  </g>
                  <defs>
                    <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="486.537" id="filter0_f_1_501" width="535.809" x="0" y="0">
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                      <feGaussianBlur result="effect1_foregroundBlur_1_501" stdDeviation="53.7262" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Screen blend blur - Rotated 180deg */}
        <div style={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          left: '-11.37px',
          top: '281.78px',
          width: '195.827px',
          height: '165.506px',
          mixBlendMode: 'screen'
        }}>
          <div style={{ flex: 'none', transform: 'rotate(180deg)' }}>
            <div style={{ height: '165.506px', opacity: '0.8', position: 'relative', width: '195.827px' }}>
              <div style={{
                position: 'absolute',
                top: '-52.18%',
                left: '-44.1%',
                right: '-44.1%',
                bottom: '-52.18%'
              }}>
                <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 368.535 338.213">
                  <g filter="url(#filter0_f_1_499)" opacity="0.6" style={{ mixBlendMode: 'screen' }}>
                    <ellipse cx="184.267" cy="169.107" fill="#D8A134" rx="97.9137" ry="82.7529" />
                  </g>
                  <defs>
                    <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="338.213" id="filter0_f_1_499" width="368.535" x="0" y="0">
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                      <feGaussianBlur result="effect1_foregroundBlur_1_499" stdDeviation="43.1768" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Blur */}
      <div style={{ position: 'absolute', left: '-25px', top: '125px', width: '337px', height: '337px' }}>
        <div style={{
          position: 'absolute',
          top: '-75.91%',
          left: '-75.91%',
          right: '-75.91%',
          bottom: '-75.91%'
        }}>
          <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 848.6 848.6">
            <g filter="url(#filter0_f_1_525)">
              <circle cx="424.3" cy="424.3" fill="url(#paint0_linear_1_525)" r="168.5" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="848.6" id="filter0_f_1_525" width="848.6" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_1_525" stdDeviation="127.9" />
              </filter>
              <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_525" x1="255.8" x2="592.8" y1="424.3" y2="424.3">
                <stop stopColor="#2E2E2E" />
                <stop offset="1" stopColor="#131313" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* White overlay path (top-left) */}
      <div style={{
        position: 'absolute',
        left: '7px',
        top: '10px',
        width: '77px',
        height: '65px',
        mixBlendMode: 'overlay'
      }}>
        <div style={{
          position: 'absolute',
          top: '-2.08%',
          left: '-1.75%',
          right: '-1.43%',
          bottom: '-1.69%'
        }}>
          <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 79.45 67.45">
            <g filter="url(#filter0_f_1_495)" style={{ mixBlendMode: 'overlay' }}>
              <path d={svgPaths.p113eee80} stroke="white" strokeWidth="0.5" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="67.45" id="filter0_f_1_495" width="79.45" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_1_495" stdDeviation="0.55" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>

      {/* Middle black bar */}
      <div style={{
        position: 'absolute',
        background: 'black',
        filter: 'blur(20.95px)',
        height: '30px',
        left: '-7px',
        top: '115px',
        width: '285px'
      }} />

      {/* MaskGroup3 - Noise overlay */}
      <div style={{ position: 'absolute', left: '-99px', top: '110px' }}>
        {/* Noise */}
        <div style={{ position: 'absolute', left: '-97px', top: '112px', width: '500px', height: '500px' }}>
          <div style={{ position: 'absolute', inset: '0', overflow: 'hidden', pointerEvents: 'none' }}>
            <img alt="" style={{
              position: 'absolute',
              left: '0',
              top: '-5.57%',
              width: '100%',
              height: '100%',
              maxWidth: 'none'
            }} src="/assets/images/noise-bg.png" />
          </div>
        </div>

        {/* Overlay blur circle */}
        <div style={{
          position: 'absolute',
          left: '-17px',
          top: '137px',
          width: '338px',
          height: '338px',
          mixBlendMode: 'overlay'
        }}>
          <div style={{
            position: 'absolute',
            top: '-17.9%',
            left: '-17.9%',
            right: '-17.9%',
            bottom: '-17.9%'
          }}>
            <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 459 459">
              <g filter="url(#filter0_f_1_493)" style={{ mixBlendMode: 'overlay' }}>
                <circle cx="229.5" cy="229.5" fill="#AAAAAA" r="169" />
              </g>
              <defs>
                <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="459" id="filter0_f_1_493" width="459" x="0" y="0">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                  <feGaussianBlur result="effect1_foregroundBlur_1_493" stdDeviation="30.25" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      {/* Bottom Info Block */}
      <div style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: '278px',
        width: '230px',
        zIndex: '10',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px'
      }}>
        {/* Name */}
        <p style={{
          fontSize: '17px',
          fontWeight: '700',
          color: '#ffffff',
          margin: '4px 0',
          lineHeight: '1',
          whiteSpace: 'nowrap'
        }}>
          {name}
        </p>

        <Divider />

        {athleteNumber && (
          <p style={{
            fontSize: '10.5px',
            color: '#D8A134',
            margin: '0',
            lineHeight: '1',
            whiteSpace: 'nowrap'
          }}>
            Spotlight Athlete #{String(athleteNumber).padStart(2, '0')}
          </p>
        )}

        {/* Sport */}
        <p style={{
          fontSize: '10.5px',
          color: 'rgba(204, 204, 204, 0.8)',
          margin: '0',
          lineHeight: '1',
          whiteSpace: 'nowrap'
        }}>
          {sport}
        </p>

        {timeLabel && (
          <p style={{
            fontSize: '10.5px',
            fontWeight: '500',
            color: '#D8A134',
            margin: '0',
            lineHeight: '1',
            whiteSpace: 'nowrap'
          }}>
            {timeLabel}
          </p>
        )}

        <Divider />
        {spotlightLabel && (
          <p style={{
            fontSize: '10.5px',
            color: '#D8A134',
            margin: '0',
            lineHeight: '1',
            whiteSpace: 'nowrap'
          }}>
            {spotlightLabel.toUpperCase()}
          </p>
        )}
      </div>

      {/* Athlete Image */}
      <div style={{
        position: 'absolute',
        height: '260px',
        left: '0',
        top: '0',
        width: '100%',
        zIndex: '6',
        overflow: 'hidden'
      }}>
        <img alt={name} style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'top center'
        }} src={image} />

        {/* Gradient fade — same as Standouts card */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '55%',
          background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 60%, #000000 100%)',
          pointerEvents: 'none',
          zIndex: 1
        }} />

        {/* Logo on top left corner */}
        <img
          src="/assets/images/logo1.png"
          alt="LegacyStat Logo"
          style={{
            position: 'absolute',
            top: '8px',
            left: '8px',
            width: '24px',
            height: '30px',
            zIndex: '8',
            objectFit: 'cover',
            pointerEvents: 'none'
          }}
        />

        {/* Gold Badge */}
        <img
          src="/assets/images/gold-badge.png"
          alt="Gold Badge"
          className="athlete-card-gold-badge"
          style={{
            position: 'absolute',
            top: '-3px',
            right: '-5px',
            width: '44px',
            height: '44px',
            zIndex: '7',
            objectFit: 'contain',
            pointerEvents: 'none',
            opacity: '0',
            transition: 'opacity 0.3s ease'
          }}
        />
      </div>

      {/* Location Badge Background Image */}
      <div style={{
        position: 'absolute',
        height: '44px',
        left: '50%',
        top: '235px',
        transform: 'translateX(-50%)',
        width: '185px',
        zIndex: '9'
      }} />

      {/* Location Badge */}
      <div style={{
        position: 'absolute',
        height: '28px',
        left: '50%',
        borderRadius: '34px',
        top: '250px',
        transform: 'translateX(-50%)',
        width: '151px',
        zIndex: '10'
      }}>
        {/* Glass background */}
        <div style={{
          position: 'absolute',
          inset: '0',
          background: 'rgba(31, 31, 31, 0.2)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderRadius: '34px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
        }} />
        {/* Gradient glass border */}
        <div style={{
          position: 'absolute',
          inset: '0',
          borderRadius: '34px',
          padding: '1px',
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 8%, rgba(255, 255, 255, 0.3) 20%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0.4) 60%, rgba(255, 255, 255, 0.3) 80%, rgba(0, 0, 0, 0.3) 92%, rgba(0, 0, 0, 0.6) 100%)',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude'
        }} />
        <div style={{
          position: 'absolute',
          display: 'flex',
          gap: '4px',
          alignItems: 'center',
          justifyContent: 'center',
          left: '50%',
          top: '6px',
          transform: 'translateX(-50%)',
          width: '139px'
        }}>
          {/* Pin Icon */}
          <div style={{ position: 'relative', flexShrink: '0', width: '16px', height: '16px' }}>
            <svg style={{ display: 'block', width: '100%', height: '100%' }} fill="none" preserveAspectRatio="none" viewBox="0 0 16 16">
              <g>
                <path d={svgPaths.p17781bc0} stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
                <path d={svgPaths.p308b3530} stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
              </g>
            </svg>
          </div>
          <p style={{
            fontSize: '12px',
            fontWeight: '500',
            lineHeight: '1.4',
            color: '#CCCCCC',
            position: 'relative',
            flexShrink: '0',
            margin: '0'
          }}>
            {location}
          </p>
        </div>
      </div>

     
    </div>
  );
}
